import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from '@/reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import { StoreProvider } from '@shared/hooks/useStore';
import RootStore from '@shared/stores';
import { userRouter } from '@user/router';
import { adminRouter } from '@admin/router';
import { IS_GROUP_ADMIN_APP } from '@shared/configs/environment';

import '@shared/styles/index.scss';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = IS_GROUP_ADMIN_APP ? adminRouter : userRouter;

window.addEventListener('storage', (event) => {
    if (event.key === 'logout-event') {
        sessionStorage.clear();
        window.location.reload();
    }
});

root.render(
    <StoreProvider store={new RootStore()}>
        <RouterProvider router={router} />
    </StoreProvider>
);

reportWebVitals();
